import axios from "axios";
import { EventEmitter } from "eventemitter3";

export default class CommitBlocksService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
  }

  execute(blocks, fileId, uploadId, cancelToken) {
    const { url, headers } = this;
    const data = { fileId, blocks, uploadId };
    axios
      .post(url, data, { headers, cancelToken })
      .then((e) => {
        if (e.data.code !== 200) {
          this.emit("error", new Error(e.data.message));
          return;
        }
        const parts = e.data.data.neededUploadBlocks || [];
        let size = 0;
        for (const part of parts) {
          size += part.size;
        }
        this.emit("complete", parts, size);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          return this.emit("abort"); 
        }
        this.emit("error", err);
      });
  }
}
